import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import "../DataSecurity/DataSecurity.css";
import CMSTranslationFile from "../DataSecurity/DataSecurity_Translation_Corp.json";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";

let userSelectedLanguage;
class DataSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    window.scrollTo(0, 0);
  }
  callback = () => {
    this.setState({ reRender: true });
  };
  render() {
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <HeaderNavBar callBack={this.callback} />
        <div className="ID_DataSecurity">
          <div className="page-title">
            {CMSTranslationFile.DS_Title[userSelectedLanguage]}
          </div>

          <section className="ds-section">
            {CMSTranslationFile.DS_Text1[userSelectedLanguage]}
          </section>

          <section className="ds-section-title">
            {CMSTranslationFile.DS_Title2[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text2A[userSelectedLanguage]}
          </section>

          <section className="ds-section">
            {CMSTranslationFile.DS_Text2B[userSelectedLanguage]}{" "}
            <span className="italic-bold">
              "{CMSTranslationFile.DS_Text2C[userSelectedLanguage]}"
            </span>
            .{CMSTranslationFile.DS_Text2D[userSelectedLanguage]}{" "}
            <span className="italic-bold">
              "{CMSTranslationFile.DS_Text2E[userSelectedLanguage]}"
            </span>
            .{CMSTranslationFile.DS_Text2F[userSelectedLanguage]}{" "}
            <span className="italic-bold">
              "{CMSTranslationFile.DS_Text2G[userSelectedLanguage]}"
            </span>
            .
          </section>

          <section className="ds-section-title">
            {CMSTranslationFile.DS_Title3[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text3A[userSelectedLanguage]}
          </section>

          <section className="ds-section-title">
            {CMSTranslationFile.DS_Title4[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text4A[userSelectedLanguage]}
            <a
              href={CMSTranslationFile.DS_Text4_Link[
                userSelectedLanguage
              ].replace(/[()]/g, "")}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue" }}
            >
              {CMSTranslationFile.DS_Text4B[userSelectedLanguage]}
            </a>
            {CMSTranslationFile.DS_Text4C[userSelectedLanguage]}
          </section>

          <section className="ds-section-title">
            {CMSTranslationFile.DS_Title5[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text5A[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text5B[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text5C[userSelectedLanguage]}
            <br />
            {CMSTranslationFile.DS_Text5D[userSelectedLanguage]}
            <br />
            {CMSTranslationFile.DS_Text5E[userSelectedLanguage]}
            <br />
            {CMSTranslationFile.DS_Text5F[userSelectedLanguage]}
            <br />
            {CMSTranslationFile.DS_Text5G[userSelectedLanguage]}
            <a
              href={
                "mailto:" +
                "" +
                CMSTranslationFile.DS_Text5H[userSelectedLanguage]
              }
              style={{ textDecoration: "none", color: "blue" }}
            >
              {CMSTranslationFile.DS_Text5H[userSelectedLanguage]}
            </a>
          </section>

          <section className="ds-section-title">
            {CMSTranslationFile.DS_Title6[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text6A[userSelectedLanguage]}
          </section>

          <section className="ds-section-title">
            {CMSTranslationFile.DS_Title7[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text7A[userSelectedLanguage]}
          </section>

          <section className="ds-section-title">
            {CMSTranslationFile.DS_Title8[userSelectedLanguage]}
          </section>
          <section className="ds-section">
            {CMSTranslationFile.DS_Text8A[userSelectedLanguage]}
          </section>
        </div>
        <ScrolltoTop />
        <Footer />
      </div>
    );
  }
}
export default DataSecurity;
